import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { numberOfVisibleDietariesSet, SingleItem } from '@citypantry/util-models';

@Component({
  selector: 'app-flexible-group-item',
  templateUrl: './flexible-group-item.component.html',
})
export class FlexibleGroupItemComponent {

  @Input()
  public item: SingleItem;

  @Input()
  public control: FormControl;

  @Input()
  public showMoreInfo: boolean;

  @Output()
  public toggleMoreInfo: EventEmitter<void> = new EventEmitter();

  public onToggleShowMoreInfo(): void {
    this.toggleMoreInfo.emit();
  }

  public hasDietaries(): boolean {
    return this.item && numberOfVisibleDietariesSet(this.item.dietaries) > 0;
  }

  public shouldShowKcals(): boolean {
    return this.item.kcal !== null && this.item.kcal >= 0;
  }
}
